import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SaidaEstoqueInserirIdentificadaComponent } from './saida-estoque-inserir-identificada.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:'', component: SaidaEstoqueInserirIdentificadaComponent}
  ])],
  exports: [RouterModule]
})
export class SaidaEstoqueInserirIdentificadaRoutingModule { }
